import styles from "./RemoveGlobalAdminModal.module.css";
import PropTypes from "prop-types";
import classNames from "classnames";

/**
 *
 * Modal used for confirmation of removing a GLOBAL admin
 *
 */

export function RemoveGlobalAdminModal({
  isOpen,
  onClose,
  onClick,
  globalAdminInfo,
}) {
  if (!isOpen) {
    return "";
  }
  return (
    <div className={styles.containerContainer}>
      <div className={styles.modalBackground} onClick={onClose} />
      <div className={styles.container}>
        <div className={styles.bold}>REMOVE GLOBAL ADMIN</div>
        <div className={styles.hr} />
        <div className={styles.description}>
          Confirm that you would like to remove the user's global admin
          permissions.
        </div>

        <div className={styles.grid}>
          <div className={styles.bold}>First Name:</div>
          <div className={styles.item}>{globalAdminInfo.adminName}</div>
          <div className={styles.bold}>Last Name:</div>
          <div className={styles.item}>{globalAdminInfo.adminName}</div>
          <div className={styles.bold}>Email Address:</div>
          <div>{globalAdminInfo.email}</div>
        </div>

        <div className={styles.buttonContainer}>
          <button
            className={classNames(styles.button, styles.cancelBtn)}
            onClick={onClose}
          >
            CANCEL
          </button>
          <button className={styles.button} onClick={onClick}>
            REMOVE
          </button>
        </div>
      </div>
    </div>
  );
}

RemoveGlobalAdminModal.propTypes = {
  isOpen: PropTypes.bool,
  onClose: PropTypes.func,
  onClick: PropTypes.func,
  globalAdminInfo: PropTypes.object,
};
